import { DnvDataItemBM } from '../../types/BusinessModel/Verification/DnvDataItemBM';
import { DnvDataItem } from '../../types/ViewModel/Verification/DnvDataItem';

export const createVerificationResponse = (dnvDataItem: DnvDataItemBM): DnvDataItem => {
    return {
        imo: dnvDataItem.imo,
        vesselName: dnvDataItem.vessel_Name,
        year: dnvDataItem.year,
        checkNumber: dnvDataItem.check_Number,
        checkName: dnvDataItem.check_Name,
        severity: dnvDataItem.severity,
        details: dnvDataItem.details,
        recommendation: dnvDataItem.recommendation,
        eevent: dnvDataItem.eevent,
        eventDateTime: dnvDataItem.event_DateTime,
        legStart: dnvDataItem.leg_Start_DateTime,
        legEnd: dnvDataItem.leg_End_DateTime,
        legMode: dnvDataItem.leg_Mode,
        portFromCode: dnvDataItem.port_From_Code,
        portToCode: dnvDataItem.port_To_Code,
        legType: dnvDataItem.leg_Type,
        dnvRecordId: dnvDataItem.dnvRecordId,
        schemaName: dnvDataItem.schemaName,
        updatedDateTime: dnvDataItem.updatedDateTime,
        showDetails: false,
    };
};

export const createVerificationResponseList = (reportMetadataList: DnvDataItemBM[]) =>
    reportMetadataList.map((reportMetadata) => createVerificationResponse(reportMetadata));
